import { useEffect } from "react";
import { IContainerApp } from "../navigationButtonComponents/loansTab/containerApp/IContainerApp";
import { v4 as uuid } from "uuid";
import ViewContract from "./viewContract";
import SignContract from "./signContract";
import { IFormInnerState } from "../requestSteps/form/IFormInnerState";
import Accept from "../loanResult/accept";
import Reject from "../loanResult/reject";
import { TContractState } from "./IContract";
import { useLocation, useNavigate } from "react-router-dom";
export default function WaitSign({ referenceKey, setStep }: IFormInnerState) {
    const navigate = useNavigate();
    const location = useLocation();
    const setState = (state: TContractState) => navigate(`/loans/request/${state}`);

    if (location.pathname.endsWith('/signContract')) return <SignContract setState={setState} referenceKey={referenceKey} setStep={setStep} />;
    if (location.pathname.endsWith('/accept')) return <Accept />;
    if (location.pathname.endsWith('/reject')) return <Reject />;
    return <ViewContract setState={setState} referenceKey={referenceKey} />;
}
